module.exports = __webpack_public_path__ + "img/shipinzhibo.2edffb64.png";